import { defineStore } from "pinia";
import { ref } from "vue";
import { chatClient, useAuthStore } from "./authStore";

export const useChatStore = defineStore("chat", () => {
    const activeChannel = ref(null);
    const authStore = useAuthStore();

    const startChat = async (userId1, userId2, userName2) => {
        if (!chatClient.user && authStore.user) {
            try {
                const token = authStore.chatToken;
                
                await chatClient.connectUser(
                    {
                        id: authStore.user.userId,
                        name: authStore.user.username,
                        image: authStore.profileImageUrl,
                    },
                    token
                );
            } catch (error) {
                console.error("Failed to reconnect to Stream chat", error);
                return;
            }
        }
        
        if (!chatClient.user) {
            console.error("Stream client not connected. User must be logged in.");
            return;
        }
        
        const sortedIds = [userId1, userId2].sort();
        const channelId = `chat_${sortedIds[0]}_${sortedIds[1]}`;
        
        const channel = chatClient.channel("messaging", channelId, {
            name: `Chat with ${userName2}`,
            members: [userId1, userId2],
        });

        await channel.watch();
        activeChannel.value = channel;
        return channel;
    };

    const closeChat = () => {
        activeChannel.value = null;
    };

    return { activeChannel, startChat, closeChat };
});